module.exports = __webpack_public_path__ + "static/media/icon-fiscal.77654c3e.svg";